import { Skill } from '../types';

export const skills: Skill[] = [
  { name: 'Agile Methodologies', percentage: 90, type: 'circular' },
  { name: 'CICD Tools', percentage: 80, type: 'circular' },
  { name: 'React', percentage: 90, type: 'circular' },
  { name: 'Angular', percentage: 90, type: 'circular' },
  { name: 'Node.js', percentage: 90, type: 'circular' },
  { name: 'JavaScript', percentage: 85, type: 'circular' },
  { name: 'Docker', percentage: 75, type: 'circular' },
  { name: 'PostgreSQL', percentage: 85, type: 'circular' },
  { name: 'HTML5/CSS3', percentage: 80, type: 'bar', barClass: 'progress-bar-1' },
  { name: 'AWS (Amazon Web Services)', percentage: 90, type: 'bar', barClass: 'progress-bar-2' },
  { name: 'Kubernetes (K8s)', percentage: 75, type: 'bar', barClass: 'progress-bar-3' },
  { name: 'Java', percentage: 85, type: 'bar', barClass: 'progress-bar-4' },
  { name: 'Design', percentage: 100, type: 'bar', barClass: 'progress-bar-5' },
  { name: 'Terraform', percentage: 75, type: 'bar' },
  { name: 'Python', percentage: 65, type: 'bar', barClass: 'progress-bar-1' },
  { name: 'TypeScript', percentage: 80, type: 'bar', barClass: 'progress-bar-3' },
];
